import Header from "../Header";
import Footer from "../Footer";
import Breadcrumbs from "../Breadcrumbs";
import BannerImg from "../assets/Images/banner-1920x450.png";
import BottomLogoImg from "../assets/Images/bottom-logo.png";
import MainImg from "../assets/Images/rules.png";
import TitleImg from "../assets/Images/title.png";
import Triangle from "../assets/Images/triangle.png";
import LineImg from "../assets/Images/line.png";
import ImageTextLayout from "../shared/ImageTextLayout";
import "./WhyHKASRulesPage.scss";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const WhyHKASRulesPage = () => {
  const { t } = useTranslation();
  return (
    <>
      <Header />
      <div className="banner">
        <img src={BannerImg} alt="" />
        <div className="banner_title res">
          <h1 className="banner-main-title">{t("why_HKAS_Rules_page_header")}</h1>
          <p className="banner-subtitle">{t("why_HKAS_Rules_page_header2")}</p>
        </div>
      </div>
      <Breadcrumbs>
        <Link>{t("breadcrumbs_why_HKAS_Rules_page_link1")}</Link>
        <span>{t("breadcrumbs_why_HKAS_Rules_page_span")}</span>
        <Link>{t("breadcrumbs_why_HKAS_Rules_page_link2")}</Link>
      </Breadcrumbs>
      <ImageTextLayout
        image={MainImg}
        imageAlt="HKAS Rules illustration"
        titleIcon={TitleImg}
        title={t("why_HKAS_Rules_page_h3")}
        className="rules-layout"
      >
        <p>{t("why_HKAS_Rules_page_text1")}</p>
        <p>{t("why_HKAS_Rules_page_text2")}</p>
        <p>{t("why_HKAS_Rules_page_text3")}</p>
        <div className="rules-download">
          <img src={Triangle} alt="Download icon" className="download-icon" />
          <p className="download-text">
            <a href="https://www.hkarbsoc.org.hk/image/catalog/Arbitration/150103994115091600.pdf" className="download-link">
              {t("why_HKAS_Rules_page_text4")}
            </a>
          </p>
        </div>
      </ImageTextLayout>
      <div className="rules-divider">
        <img src={LineImg} alt="Decorative line" className="divider-line" />
      </div>
      <div className="temporary">
        <img src={BottomLogoImg} alt="" className="bottom-logo" />
      </div>

      <Footer />
    </>
  );
};

export default WhyHKASRulesPage;
